"use strict";
exports.__esModule = true;
exports["default"] = (function (ctx, options) {
    ctx.textAlign = "center";
    ctx.fillText(options.content, Math.floor(ctx.canvas.width / 2), Math.floor(ctx.canvas.height / 2));
});
